import { connect } from "react-redux";

import { open as openPaymentModal } from "ducks/payment";
import ReadReceiptRateCard from "./ReadReceiptRateCard";

const mapDispatchToProps = {
	openPaymentModal,
};

export default connect(null, mapDispatchToProps)(ReadReceiptRateCard);



// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/index.js